import { useTranslation } from 'react-i18next'

import { type Quote } from '../../../../../modules/quotes'

type MinLabourTimeProps = {
  quote: Quote
}

const MinLabourTime: React.FC<MinLabourTimeProps> = ({ quote }) => {
  const { t } = useTranslation()

  const minLabour = quote.companyBranch.labour?.minLabourTime
  if (!minLabour) {
    return null
  }

  return (
    <div className="my-6 text-sm italic text-gray-500">
      *{ t('quotes.minLabourTime') }:
      <strong>{ minLabour }{ t('units.hour') }</strong>
    </div>
  )
}

export default MinLabourTime
